import { Pipe, PipeTransform } from '@angular/core';
import { DirectPropertyCheck } from '@app/shared/services/properties/properties.service';

@Pipe({
  standalone: false,
  name: 'propertyHasBlockCheck',
})
export class PropertyHasBlockCheckPipe implements PipeTransform {
  transform(checks: DirectPropertyCheck[]): boolean {
    if (checks && checks.length) {
      return checks.some((check) => check.result === 'block');
    }
    return false;
  }
}
